module.exports = __webpack_public_path__ + "img/Kotlin_icon.c49b566e.png";